module.exports = __webpack_public_path__ + "img/tip-image-4.c3fe6ee9.png";